<template>
  <k-page class="page-settings-starts-price">
    <the-settings-starts-price />
  </k-page>
</template>

<script>
/**
 * Component: page-settings-starts-price - Страница настроек цены челенджа стратов
*
* @version 1.0.0
*/


// Components
import KPage from '@/components/KPage.vue';
import TheSettingsStartsPrice from '@/components/TheSettingsStartsPrice.vue';


export default {
  name: 'page-settings-starts-price',

  components: {
    KPage,
    TheSettingsStartsPrice,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-settings-starts-price {
  $this: &;
}
</style>
